
import ast from './ast';

const astPlugin = {

  install(Vue) {
    Vue.prototype.$astSparkPlugin = {
      // ==============入口模块===================
      entryPoint: () => ({}),
      // ==============APP模块================
      isAPP: ast.isAPP,
      gotoAPP: ast.gotoAPP,
      setAPPShare: ast.setAPPShare,
      goAPPShare: ast.goAPPShare,
      setImageShare: ast.setImageShare,
      imageShare: ast.imageShare,
      getShareUrl: ast.getShareUrl,
      openView: ast.openView,
      openScheme: ast.openScheme,
    };
  },
};
export default astPlugin;
